import IMAGE from '@/config/src.js'
import {PATH} from '@/config/pathConfig.js'
let srcMixins = {
  data () {
    return{
      IMAGE: IMAGE,
      PATH: PATH,
    }
  }
}

export default srcMixins



// WEBPACK FOOTER //
// ./src/mixins/srcMixins.js